export default "__VITE_ASSET__kqV02tgI__"